import { createFileRoute } from '@tanstack/react-router';
import { StandingPage } from '@/features/payroll/standing-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/payroll_/standing')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/payroll/standing');
  },
  component: StandingPage,
});
